module.exports = __webpack_public_path__ + "media/images/icon_arrow_down-08bdcd3660adffc3c379f564d53d10d0.png";